import { useEffect, useState } from "react";
import { api, API_BASE } from "@/lib/api";
import { confirmRemove } from "@/lib/confirm";
import { Trash2, Download, ChevronDown, ChevronUp } from "lucide-react";

export default function IncubationAdmin() {
  const [items, setItems] = useState([]);
  const [openId, setOpenId] = useState(null);
  const refresh = () => api.get("/incubation/applications").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { refresh(); }, []);

  const del = async (id) => { if (!confirmRemove("this incubation application")) return; await api.delete(`/incubation/applications/${id}`); refresh(); };
  const exportCsv = async () => {
    const res = await fetch(`${API_BASE}/incubation/applications/export.csv`, { credentials: "include" });
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "incubation-applications.csv"; a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <div className="tag">// {items.length} incubation applications</div>
        <button data-testid="incubation-export-csv" onClick={exportCsv} className="inline-flex items-center gap-2 border border-brand text-brand hover:bg-brand hover:text-white px-3 py-1.5 text-sm transition-colors">
          <Download className="w-4 h-4" /> Export CSV
        </button>
      </div>
      <div className="border border-ink/10 bg-white divide-y divide-ink/10" data-testid="incubation-admin-list">
        {items.map((a) => {
          const open = openId === a.id;
          return (
            <div key={a.id} data-testid={`incubation-row-${a.id}`}>
              <div className="p-4 grid md:grid-cols-12 gap-3 items-center text-sm">
                <div className="md:col-span-2 font-mono text-[11px] text-teal">{a.reference}</div>
                <div className="md:col-span-4">
                  <div className="font-display font-bold text-brand leading-snug">{a.startup_name}</div>
                  <div className="text-xs text-ink/60">{a.founder_name} · {a.email}</div>
                </div>
                <div className="md:col-span-3 text-xs text-ink/70">{a.program}</div>
                <div className="md:col-span-2 text-xs text-ink/60">{a.sector ? `${a.sector} · ` : ""}{a.submitted_at?.substring(0, 10)}</div>
                <div className="md:col-span-1 flex justify-end gap-3">
                  <button data-testid={`incubation-toggle-${a.id}`} onClick={() => setOpenId(open ? null : a.id)} className="text-brand" aria-label="Toggle details">
                    {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                  </button>
                  <button data-testid={`incubation-del-${a.id}`} onClick={() => del(a.id)} className="text-red-500 hover:text-red-600" aria-label="Delete"><Trash2 className="w-4 h-4" /></button>
                </div>
              </div>
              {open && (
                <dl className="px-4 pb-5 grid md:grid-cols-2 gap-x-8 gap-y-3 text-sm bg-surface pt-4">
                  {[
                    ["Phone", a.phone], ["Website", a.website], ["Stage", a.stage],
                    ["Team size", a.team_size ? String(a.team_size) : ""],
                    ["Description", a.description], ["Support needed", a.support_needed],
                  ].filter(([, v]) => v).map(([k, v]) => (
                    <div key={k}>
                      <dt className="font-mono text-[10px] uppercase tracking-widest text-ink/60">{k}</dt>
                      <dd className="text-ink/85 whitespace-pre-line">{v}</dd>
                    </div>
                  ))}
                </dl>
              )}
            </div>
          );
        })}
        {items.length === 0 && <div className="p-6 text-ink/60 text-sm">No incubation applications yet.</div>}
      </div>
    </div>
  );
}
